import { TravelExpense } from '../../lib/types/models/travel-expenses/travel-expenses'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getMissionToStaffTravelExpenses(id: number) {
  return restApiClient
    .url(constructApiUrl(API.missionToStaffs.getTravelExpenses.url, { id }))
    .get<TravelExpense[]>()
}
